<template>
    <div class="flex px-4">
        <div class="sl-basket-line-details-col">
            <div class="flex flex-col">
                <div class="sl-basket-line-details__title">
                    {{ $t('order_table.details.section.complements.title') }}
                </div>

                <!-- Added by -->
                <div v-if="isStaff" class="sl-basket-line-details-line">
                    <div class="sl-basket-line-details-line__label">
                        {{ t('order_table.details.section.users.added_by.label') }}:
                    </div>

                    <div class="sl-basket-line-details-line__value">
                        <img
                            v-if="loadingAddedBy"
                            src="/img/loader.gif"
                            class="inline h-4"
                            alt="…"
                        >
                        <template v-else>
                            {{ addedBy }}
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import useBasketLineAddedByComposable from '@/composables/BasketLineAddedByComposable';

// ------------------------------------------------------------ PROPS

const props = defineProps({
    basketLine:
    {
        type:     Object,
        required: true,
    },
});

// ------------------------------------------------------------ COMPOSABLES

const { t } = useI18n({ useScope: 'global' });
const store = useStore();
const {
    addedBy,
    loadingAddedBy,
    fetchAddedBy,
} = useBasketLineAddedByComposable();

// ------------------------------------------------------------ COMPUTED

const isStaff = computed(() => store.getters['account/isStaff']);

// ------------------------------------------------------------ LIFECYCLE HOOKS

onMounted(() =>
{
    if(isStaff.value)
    {
        fetchAddedBy(props.basketLine.id);
    }
});
</script>

<style scoped>
@reference "#main.css";

.sl-basket-line-details-col
{
    @apply w-1/3 pb-4;
}

.sl-basket-line-details__title
{
    @apply text-gray-700 text-sm mt-4 mb-1;
}

.sl-basket-line-details-line
{
    @apply flex flex-wrap;
}

.sl-basket-line-details-line__label
{
    @apply text-xs text-gray-500;
}

.sl-basket-line-details-line__value
{
    @apply pl-2 text-xs text-primary-500;
}
</style>
